$(function () {
    $('.campaign-tab-tabs li').click(function () {
        $('.campaign-tab-tabs li a').removeClass('hover');
        $(this).find('a').addClass('hover');
        $('.campaign-tab-content > div').hide();
        $('.campaign-tab-content > div').eq($(this).index()).show();
    });

  function separator(numb) {
    var str = numb.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
}

    if($('section.single-campaign-detail').get(0)){
        $(document).on('click', '.partial-display.none .more-all a', function () {
            $(this).closest('.partial-display').removeClass('none');
            $(this).closest('.more-all').remove();
        })

        $.post( "https://creators.heavenbuy.com/api/cases", {page_handle: $('section.single-campaign-detail').data('id'), customer: $('section.single-campaign-detail').data('customer')})
            .done(function(e) {
                for (let x = 0; x < e.contents.length; x++){
                    let el = $(`
                        <div class="contact-update-item">
                            <div class="title">${e.contents[x].title}</div>
                            ${e.contents[x].privacy == 1 ? `
                            <div class="date">${e.contents[x].release_at}</div>
                            <div class="text">${e.contents[x].body}</div>
                            <div class="body">${e.contents[x].body}</div>
                            <a class="more">閱讀更多</a>
                            ` : `
                            <a class="login-content">
                            <span class="t">只有贊助人看得到這則更新</span><span class="b">${e.contents[x].release_at}</span>
                            </a>
                            `}
                        </div>`);

                    el.find('.text').html(el.find('.body').text())

                    $('#contact-update .items').append(el);
                }

              //$('#api-target_price').html(separator(e.target_price));
              //$('#api-buy_price').html(separator(e.buy_price));
              //$('#api-buy_number').html(separator(e.buy_number));
              //$('#api-day').html((e.day));
              //$('#api-start_at').html((e.start_at));
              //$('#api-end_at').html((e.end_at));
              //$('.progress-value').css('width', (e.completion_rate)+'%');
            });

        $(document).on('click', '#contact-update .items .more', function () {
            $('#contact-update .contact-update-item').removeClass('show');
            $(this).closest('.contact-update-item').addClass('show');
        });
    }

    if($('#crowd-funding-campaigns-page').get(0)){
        var page_per = 9, liquid_data = JSON.parse($('#data').html()), search = '', sort_type = 0;

        liquid_data.splice(0, 1);

        function paginate() {
            let total = $('#crowd-funding-campaigns-page .items .column.show').length;
            let page_el = $('#crowd-funding-campaigns-page .pages');

            page_el.html('');

            //if(total > 1) {
                let page = Math.ceil(total / page_per);

                page_el.append(`<a data-type="previous">上一頁</a>`);

                for(let x = 0; x < page; x++){
                    if(x == 0){
                        page_el.append(`<a class="hover" data-value="${x+1}">${x+1}</a>`);
                    }else{
                        page_el.append(`<a data-value="${x+1}">${x+1}</a>`);
                    }
                }

                page_el.append(`<a data-type="next">下一頁</a>`);
            //}
        }

        function appendData(data){
            $('#crowd-funding-campaigns-page .items').html('');

            for(let i = 0; i < data.length; i++){
                let html = `
                <a class="column show" href="${data[i].url}">
                    <img src="${data[i].image}"
                         alt="" class="gf_image" data-gemlang="en" data-width="100%" data-height="auto" title=""
                         width="600" height="350" natural-width="600" natural-height="350">
                    <div class="tit">${data[i].title}</div>
                    <div class="author">發起 BY ${data[i].vendor}</div>
                    <div class="txt">${data[i].content}</div>
                    ${data[i].start_day > 0 ? `
                        <div class="col-footer fail">
                           <div class="c-1">
                                <span class="text-1">即將啟動</span>
                                <br>
                                <span class="text-2">於 ${data[i].start_date}</span>
                            </div>
                            <div class="price">NT$0</div>
                        </div>
                    ` : ""}
                    ${data[i].start_day <= 0 && data[i].end_day > 0 ? `
                        <div class="col-footer fail">
                           <div class="time">剩下 ${data[i].end_day} 天</div>
                           <div class="price">NT${data[i].total_currency}</div>
                        </div>
                    ` : ""}
                    ${data[i].start_day <= 0 && data[i].end_day <= 0 ?
                    data[i].percentPreSold < 100 ?
                    `
                        <div class="col-footer fail">
                           <div class="c-1">
                                <span class="text-1">集資失敗</span>
                                <br>
                                <span class="text-2">於 ${data[i].end_show_date}</span>
                            </div>
                            <div class="price">NT${data[i].total_currency}</div>
                        </div>
                    ` : `
                        <div class="col-footer success">
                           <div class="c-1">
                                <span class="text-1">成功</span>
                                <br>
                                <span class="text-2">於 ${data[i].end_show_date}</span>
                            </div>
                            <div class="price">NT${data[i].total_currency}</div>
                            <div class="num">${data[i].percentPreSold}%</div>
                        </div>
                    `  : ""}
                </a>
                `;

                $('#crowd-funding-campaigns-page .items').append(html);
            }
        }

        function search_data() {
            var temp = [];
            $.each(liquid_data, function(key, value) {
                if(search == '') {
                    temp.push(value);
                }else{
                    if(value.title.indexOf(search) !== -1){
                        temp.push(value);
                    }
                }
            });

            switch(sort_type) {
                case 1:
                    temp.sort(function (a, b) {
                        if (a.target > b.target) {
                            return -1
                        }
                        if (a.target < b.target) {
                            return 1
                        }
                        return 0;
                    });
                    break;
                case 3:
                    temp.sort(function (a, b) {
                        if (a.start_at > b.start_at) {
                            return -1
                        }
                        if (a.start_at < b.start_at) {
                            return 1
                        }
                        return 0;
                    });
                    break;
                case 2:
                    temp.sort(function (a, b) {
                        if (a.day > b.day) {
                            return -1
                        }
                        if (a.day < b.day) {
                            return 1
                        }
                        return 0;
                    });
                    break;
            }

            appendData(temp);
            paginate();
            $('#crowd-funding-campaigns-page .pages a.hover').trigger('click');
        }

        $(document).on('keypress', '#crowd-funding-campaigns-page .search input', function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                search = $.trim($(this).val())
                search_data();
            }

            event.stopPropagation();
        });

        $(document).on('click', '#crowd-funding-campaigns-page .search img', function (event) {
                search = $.trim($('#crowd-funding-campaigns-page .search input').val())
                search_data();
        });

        $(document).on('click', '#crowd-funding-campaigns-page .select-sort a', function () {
            sort_type = $(this).data('id');

            $('#crowd-funding-campaigns-page .select-sort a').removeClass('hover');
            $(this).addClass('hover');

            search_data();
        });


        $(document).on('click', '#crowd-funding-campaigns-page .pages a', function () {
            let type = $(this).attr('data-type');
            let page_el = $('#crowd-funding-campaigns-page .pages');
            let page = 1;
            let current = page_el.find('a.hover').attr('data-value');

            if(type == 'previous' || type == 'next'){
                let current_el = null;

                if(type == 'previous' && page_el.find('a.hover').prev('a').data('value')){
                    current_el = page_el.find('a.hover').prev('a');
                }

                if(type == 'next' && page_el.find('a.hover').next('a').data('value')){
                    current_el = page_el.find('a.hover').next('a');
                }

                if(current_el){
                    page_el.find('a').removeClass('hover');
                    current_el.addClass('hover');

                    page = current_el.attr('data-value');
                }else{
                    page = page_el.find('a.hover').attr('data-value');
                }

            }else{
                page_el.find('a').removeClass('hover');
                $(this).addClass('hover');

                page =  $(this).attr('data-value');
            }

            $('#crowd-funding-campaigns-page .items .column.show').each(function (index) {
                if((page_per*(Number(page) - 1)) <= index && index < (page_per*Number(page))){
                    $(this).show()
                }else{
                    $(this).hide()
                }
            });

            $('html, body').animate({scrollTop:0},500);
        });

        appendData(liquid_data);
        paginate();
        $('#crowd-funding-campaigns-page .pages a.hover').trigger('click');
    }
})
